﻿import { useState, useCallback } from 'react';
import { api } from '@/services/api';
import { config } from '@/config/env';

export interface Prospect {
  id?: string;
  codcliente: string;
  ragsociale: string;
  codazienda?: string;
  indirizzo?: string;
  cap?: string;
  localita?: string;
  prov?: string;
  regioncountry?: string;
  stato?: string;
  telefono?: string;
  email?: string;
  tipologia?: string;
  [key: string]: unknown;
}

interface ProspectListResult {
  elenco: Prospect[];
  totale: number;
}

export function useProspects() {
  const [prospects, setProspects] = useState<Prospect[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProspects = useCallback(async (codazienda?: string) => {
    if (!codazienda || codazienda === '0') { setProspects([]); return; }
    setLoading(true);
    setError(null);
    try {
      const data = await api.post<ProspectListResult>(
        'clienti/ricerca-clienti-azienda/' + config.SITE + '/' + codazienda + '/' + config.NOME_APP,
        { camporicerca: '', tipologia: 'P' }
      );
      setProspects(data?.elenco || []);
    } catch (err: any) {
      setError(err.message);
      setProspects([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveProspect = useCallback(async (prospect: Prospect): Promise<boolean> => {
    try {
      await api.post('lmeet/crudapi/' + config.SITE + '/clienti/insert', [prospect]);
      return true;
    } catch { return false; }
  }, []);

  const updateProspect = useCallback(async (prospect: Prospect): Promise<boolean> => {
    try {
      await api.post('lmeet/crudapi/' + config.SITE + '/clienti/update', [prospect]);
      return true;
    } catch { return false; }
  }, []);

  const deleteProspect = useCallback(async (id: string): Promise<boolean> => {
    try {
      await api.del('lmeet/crudapi/' + config.SITE + '/clienti/' + id);
      return true;
    } catch { return false; }
  }, []);

  return { prospects, loading, error, fetchProspects, saveProspect, updateProspect, deleteProspect };
}
